import gql from 'graphql-tag';

export const CREATE_EVENT = gql`
  mutation CreateEvent(
    $start: DateTime!
    $end: DateTime
    $type: String!
    $comment: String
    $machine: String!
  ) {
    createEvent(
      input: {
        start: $start
        end: $end
        type: $type
        machine: $machine
        comment: $comment
      }
    ) {
      id
      changeoverExpand {
        id
      }
    }
  }
`;

export const UPDATE_EVENT = gql`
  mutation UpdateEvent(
    $id: ID!
    $start: DateTime!
    $end: DateTime
    $type: String!
    $comment: String
  ) {
    updateEvent (
      input: {
        id: $id
        start: $start
        end: $end
        type: $type
        comment: $comment
      }
    ) {
      id
      changeoverExpand {
        id
      }
    }
  }
`;

export const DELETE_EVENT = gql`
  mutation DeleteEvent($id: ID!) {
    deleteEvent (
      input: {
        id: $id
      }
    ) {
      id
    }
  }
`;

/**
 * Use it to categorize multiple event
 * @type {DocumentNode}
 */
export const CATEGORIZE_EVENT = gql`
  mutation CategorizeEvent($input: CategorizationEventInput!) {
    categorizeEvents(input: $input)
    {
      created{
        fail
        success {
          id
          start: startISO8601
          end: endISO8601
        }
      }
      updated{
        fail
        success
        {
          id
        }
      }
      deleted{
        fail
        success
        {
          id
        }
      }
    }
  }
`;
